import * as React from "react";
import { Link } from "@mui/material";
import { directionsUrl } from "./DirectionsChip";

/**
 * An address as a link to Google Maps directions, opening the same page as the Directions chip. Without an address to
 * look up it is just the text, since there is nowhere to send anyone.
 *
 * `children` is what to show (often the address with the city appended); `address` is what is looked up.
 */
export default function AddressLink({ address, children }) {
  if (!address) return <>{children}</>;
  return (
    <Link
      href={directionsUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      // Keeps the text's own muted color, underlined so it reads as a link, and darkens on hover.
      color="inherit"
      underline="always"
      sx={{ "&:hover": { color: "text.primary" } }}
    >
      {children}
    </Link>
  );
}
